import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { Bundle } from "@memorang/types/src/bundle";
import type { BundleMetaData } from "@memorang/types/src/bundle";
import axios from "axios";
import { commerceBasePath } from "./constants";
import type { CreateCheckoutSessionResponse } from "./types";
export async function fetchProductDetails({
	tenantId,
	numericId,
}: {
	tenantId: string;
	numericId: number;
}): Promise<Bundle> {
	const { data } = await axios.post(
		`${API_BASE_URL}/aibl-query/get-product-details`,
		{
			numericId,
			tenantId,
		},
	);

	return data.data.productDetails;
}

export async function fetchProductMetadata({
	tenantId,
	productId,
	userId,
}: {
	tenantId: string;
	productId: string;
	userId: string;
}): Promise<BundleMetaData> {
	const { data } = await axios.post(
		`${API_BASE_URL}/aibl-query/get-product-metadata`,
		{
			productId,
			tenantId,
			userId,
		},
	);

	return data.data;
}

export async function createCheckoutSession({
	userId,
	payment,
}: {
	userId: string;
	payment: {
		productId: string;
		quantity: number;
		planId: number;
		successUrl: string;
		cancelUrl: string;
	};
}): Promise<CreateCheckoutSessionResponse> {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/${commerceBasePath}/product/checkout`,
		{
			payment,
			userId,
		},
	);

	return data.data;
}
